import { createContext, useContext } from 'react'

const FlowContext = createContext({
  flow: null,
  pushFlow: () => {},
  popFlow: () => {},
})

const useFlow = () => useContext(FlowContext)

const getFlow = fallback => {
  let flow = FlowContext?._currentValue?.flow

  // `Null` means there is no flow yet, but we can use the fallack
  // `undefined` is different, this means that the flow is empty.
  if (flow === null) {
    flow = fallback
  }

  return flow || ''
}

const setFlow = flow => {
  FlowContext._currentValue.flow = flow
}

const FlowProvider = ({ children, value }) => {
  const pushFlow = newFlow => {
    FlowContext._currentValue.lastFlow = FlowContext._currentValue.flow
    FlowContext._currentValue.flow = newFlow
  }
  const popFlow = () => {
    FlowContext._currentValue.flow = FlowContext._currentValue.lastFlow
  }

  return (
    <FlowContext.Provider value={{ flow: value, pushFlow, popFlow }}>
      {children}
    </FlowContext.Provider>
  )
}

export { getFlow, setFlow, FlowProvider, useFlow, FlowContext }
